var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.deviceOperatorsGroup,"multiple":true,"chips":"","small-chips":"","deletable-chips":"","item-text":"name","item-value":"id","label":_vm.$trans('report.field.device-operators-groups')},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }